let language = {

    "STORE_EMAIL_SETTING_TITLE": "Tracking Email Setting",
    
    "STORE_EMAIL_SETTING_DESP": "Automatically send tracking numbers to customers via email.",

    "STORE_EMAIL_SETTING_NOTIFY_TYPE1": "Disable",
    
    "STORE_EMAIL_SETTING_NOTIFY_TYPE2": "Send emails through {{appName}}'s email server",
    
    "STORE_EMAIL_SETTING_NOTIFY_TYPE3": "Send emails through my own email server",
    
    "STORE_EMAIL_SETTING_FORM_EMAIL_ADDRESS_LABEL": "Email address:",
    
    "STORE_EMAIL_SETTING_FORM_PASSWORD_LABEL": "Email password:",
    
    "STORE_EMAIL_SETTING_FORM_SMTP_SERVER_LABEL": "SMTP server:",
    
    "STORE_EMAIL_SETTING_FORM_SMTP_PORT_LABEL": "SMTP port:",
    
    "STORE_EMAIL_SETTING_FORM_SMTP_SSL_LABEL": "SSL",
    
    "STORE_EMAIL_SETTING_TEST_SEND_BTN": "Test",
    
    "STORE_EMAIL_SETTING_SAVE_BTN": "Save",
    
    "STORE_EMAIL_SETTING_SEND_SUCCESS": "Send success",
    
    "STORE_EMAIL_SETTING_SAVE_SUCCESS": "Save success",
    
    "STORE_EMAIL_SETTING_SAVE_CONFIRM_TITLE": "Tracking Email Setting",
    
    "STORE_EMAIL_SETTING_SAVE_CONFIRM_CONTENT": "Before saving, please double-check that all your email server details are correctly set.",
    
    // send-email-modal
    "SEND_EMAIL_RECEIVE_MAIL_HEADER_TITLE": "Email Server Test",
    
    "SEND_EMAIL_RECEIVE_MAIL_CONTENT": "Enter your email address to receive a test shipping confirmation. We'll send you a test tracking email to verify your store's email settings. This may take a few minutes.",
    
    "SEND_EMAIL_ADDRESS_EMPTY_TIP": "Can't be empty!",
    
    "SEND_EMAIL_ADDRESS_INCORRECT_FORMAT_TIP": "The email format is incorrect",
    
    "SEND_EMAIL_ADDRESS_CANCEL_BTN": "Cancel",
    
    "SEND_EMAIL_ADDRESS_SEND_BTN": "Send",
    "SEND_EMAIL_ADDRESS_PLEASE_ENTER_A_VALID": "Please enter a valid email address",

};

export { language }